import { Component, OnInit } from '@angular/core';
import { QualityreportListService } from './qualityreport-list.service';
import { QCReportFilter } from "./models/QualityReport";
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { QcReportDetailDTO, EurofinsControlParamsDTO } from './models/QCReportDTO'
import { QcreportDetailService } from '../qcreport-detail/qcreport-detail.service';

@Component({
  selector: 'app-qualityreport-list',
  templateUrl: './qualityreport-list.component.html',
  styleUrls: ['./qualityreport-list.component.css']
})
export class QualityreportListComponent implements OnInit {

  selectedFilter: string;

  reportFilters = QCReportFilter;

  searchedDate: string;
  searchedBarcode: string;
  qcReports: QcReportDetailDTO[];
  cols: any[];
  errorHandler: ErrorHandler = new ErrorHandler;
  displayDialog: boolean = false;
  id: string;
  qcReportDetail: QcReportDetailDTO = new QcReportDetailDTO();
  eurofinsControl: EurofinsControlParamsDTO[] = [];

  constructor(private qcService: QualityreportListService, private messagesService: MessagesService, private qcreportDetailService: QcreportDetailService) { }


  ngOnInit() {

    this.selectedFilter = this.reportFilters.NOT_DECIDED;

    this.searchedBarcode = "";
    this.searchedDate = "";
    this.getQualityReport(this.reportFilters.NOT_DECIDED, this.searchedBarcode, this.searchedDate);
    this.cols = [

      { field: 'plateName', header: 'Report name' },
      { field: 'plateQCStatus', header: 'Result' },
      { field: 'action', header: 'Action' }
    ];
  }

  getQualityReport(selectedFilter: QCReportFilter, searchedBarcode: string, searchedDate: string) {

    this.qcService.getQualityReport(selectedFilter, searchedBarcode, searchedDate).subscribe(
      result => {
        {
          if (!result) {
            return;
          }

          this.qcReports = result.data;
        }
      },
      error => {
        console.log(error);
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      })
  }

  // gets the QC report detail response
  getQCReport(report: QcReportDetailDTO) {
    this.eurofinsControl = [] ;
    this.qcReportDetail = new QcReportDetailDTO();
    this.qcreportDetailService.getQCReportService(report.id).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.qcReportDetail = results.data;
        (!this.qcReportDetail.qcParams) ?
          this.eurofinsControl = [] : this.qcReportDetail.qcParams.forEach(element => {
            if (element != null) {
              this.eurofinsControl.push(element);
            }
          });
        this.displayDialog = true;
        this.id = report.id;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
      }
    )
  }

  //close dialog on click of back button
  hideDialog(){
    this.displayDialog = false;
    var qcFilter : QCReportFilter = QCReportFilter[this.selectedFilter];
    this.getQualityReport(qcFilter, this.searchedBarcode, this.searchedDate);
  }
}
